<div class="layout horizontal center middle" style="width: 100%; height: 120px; margin-bottom: 16px;">
    <app-flipping-logo height="120px" 
                       width="120px"
                       frontImage="./assets/images/login.svg"
                       frontImageHeight="100px">
    </app-flipping-logo>
</div>
<!--
PRIMA FASE
-->
<ng-container *ngIf="!submitDone">
    <!--
    ISTRUZIONI
    -->
    <div style="color:black">
        <p style="color:black" *ngIf="routingDataService.currentRoutingNodeId=='set_password'" class="message">{{'RESET_AND_GENERATE_PASSWORD.SET_PASSWORD_INSTRUCTIONS'|translate}}</p>
        <p style="color:black" *ngIf="routingDataService.currentRoutingNodeId=='reset_password'" class="message">{{'RESET_AND_GENERATE_PASSWORD.RESET_PASSWORD_INSTRUCTIONS'|translate}}</p>
    </div>
    <app-form-field #usernameFormField type="EMAIL" [label]="'RESET_AND_GENERATE_PASSWORD.USERNAME'|translate"
                    [settings]="settings.fieldsSettings.username"
                    [value]="valuesForInput.username"
                    (modelChange)="updateCurrentValue('username',$event)"
                    [specifiedAttributes]="specifiedAttributes.username"
                    (enterPressure)="submit()">
    </app-form-field>
    <div class="layout horizontal space-between middle">
        <app-button [label]="'CANCEL'|translate" icon="arrow-left" (click)="cancel()" [disabled]="formSubmitting"></app-button>
        <app-button [label]="'RESET_AND_GENERATE_PASSWORD.CONFIRM'|translate" primary="true" icon="check" (click)="submit()" [disabled]="someErrors || formSubmitting"></app-button>
    </div> 
</ng-container>
<!--
SECONDA FASE
-->
<ng-container *ngIf="submitDone">
    <!--
    MESSAGGIO DI FEEDBACK
    -->
    <ng-container *ngIf="routingDataService.currentRoutingNodeId=='set_password'">
        <div [innerHtml]="'RESET_AND_GENERATE_PASSWORD.SET_PASSWORD_FEEDBACK'|translate"></div>
    </ng-container>
    <ng-container *ngIf="routingDataService.currentRoutingNodeId=='reset_password'">
        <div [innerHtml]="'RESET_AND_GENERATE_PASSWORD.RESET_PASSWORD_FEEDBACK'|translate"></div>
    </ng-container>
</ng-container>